import React from 'react';
import {
  Typography, Box, Card, InputField,
} from 'vindi-ds-components';
import tokens from 'vindi-ds-tokens';
import templateCards from '@pages/product/templates/template_pricing';

const PricingCards = ({ handleChange, activeSchema }) => (
  <>
    <Box display='flex' justifyContent='space-between' gap='0.5em' marginBottom='1.5em'>
      {Object.entries(templateCards).map((templateCard) => {
        const [pricingSchema, card] = templateCard;
        return (
          <InputField
            radio
            name='schema_type'
            defaultValue='flat'
            value={pricingSchema}
            handleChange={handleChange}
            key={pricingSchema}
            label={
              <PricingCard {...card} active={activeSchema === pricingSchema} />
            }
          />
        );
      })}
    </Box>
  </>
);

const PricingCard = ({ title, subtitle, active }) => {
  const cssActiveCard = {
    background: tokens.color.brand.secondary['050'].value,
    border: `1px solid ${tokens.color.brand.secondary['100'].value}`,
  };
  const cssAditionalAttributes = active ? cssActiveCard : {};

  return (
    <Card
      boxShadow='level1'
      borderRadius='small'
      css={{
        width: '7em',
        height: '10.5em',
        padding: '12px',
        ...cssAditionalAttributes,
      }}
    >
      <Box mb='1em' height='2em'>
        <Typography variant='body2' component='h3'>
          {title}
        </Typography>
      </Box>
      <Typography variant='caption' paragraph>{subtitle}</Typography>
    </Card>
  );
};

export default PricingCards;
